
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_1wf8f_13",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_1wf8f_1",
  "root": "awsui_root_mx3cw_1wf8f_48",
  "hidden": "awsui_hidden_mx3cw_1wf8f_83",
  "alert-wrapper": "awsui_alert-wrapper_mx3cw_1wf8f_139",
  "initial-hidden": "awsui_initial-hidden_mx3cw_1wf8f_151",
  "header": "awsui_header_mx3cw_1wf8f_156",
  "header-replacement": "awsui_header-replacement_mx3cw_1wf8f_157",
  "action": "awsui_action_mx3cw_1wf8f_161",
  "action-slot": "awsui_action-slot_mx3cw_1wf8f_165",
  "action-button": "awsui_action-button_mx3cw_1wf8f_166",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_1wf8f_170",
  "text": "awsui_text_mx3cw_1wf8f_202",
  "icon": "awsui_icon_mx3cw_1wf8f_209",
  "message": "awsui_message_mx3cw_1wf8f_212",
  "action-wrapped": "awsui_action-wrapped_mx3cw_1wf8f_216",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_1wf8f_220",
  "icon-size-big": "awsui_icon-size-big_mx3cw_1wf8f_224",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_1wf8f_228",
  "content": "awsui_content_mx3cw_1wf8f_232",
  "content-replacement": "awsui_content-replacement_mx3cw_1wf8f_233",
  "dismiss": "awsui_dismiss_mx3cw_1wf8f_237",
  "dismiss-button": "awsui_dismiss-button_mx3cw_1wf8f_243",
  "type-error": "awsui_type-error_mx3cw_1wf8f_247",
  "type-warning": "awsui_type-warning_mx3cw_1wf8f_255",
  "type-success": "awsui_type-success_mx3cw_1wf8f_263",
  "type-info": "awsui_type-info_mx3cw_1wf8f_271"
};
  